import { FC } from "react";
import _ from "lodash";
import { classNames, wrapImage } from "utils";

interface AvatarProps {
  src?: string;
  alt: string;
  size?: ("xs" | "sm" | "md" | "lg" | "xl" | "2xl");
  disabled?: boolean;
}

const Avatar: FC<AvatarProps> = ({ src, alt, size = "sm", disabled }) => {

  if (src?.length) {
    return (!disabled ?
      wrapImage(
        <img className={classNames(
          size === "xs" ? "h-8 w-8 " : "",
          size === "sm" ? "h-10 w-10 " : "",
          size === "md" ? "h-14 w-14 " : "",
          size === "lg" ? "h-20 w-20 " : "",
          size === "xl" ? "h-28 w-28 " : "",
          size === "2xl" ? "h-36 w-36" : "",
          "rounded-full object-cover z-0"
        )} src={src} alt={alt}
        />
      ) : (
        <img className={classNames(
          size === "xs" ? "h-8 w-8 " : "",
          size === "sm" ? "h-10 w-10 " : "",
          size === "md" ? "h-14 w-14 " : "",
          size === "lg" ? "h-20 w-20 " : "",
          size === "xl" ? "h-28 w-28 " : "",
          size === "2xl" ? "h-36 w-36" : "",
          "rounded-full object-cover z-0"
        )} src={src} alt={alt} />
      )
    );
  }
  return (
    <div className={classNames(
      size === "xs" ? "h-8 w-8 " : "",
      size === "sm" ? "h-10 w-10 " : "",
      size === "md" ? "h-14 w-14 " : "",
      size === "lg" ? "h-20 w-20 " : "",
      size === "xl" ? "h-28 w-28 " : "",
      "rounded-full flex items-center justify-center bg-gray-200"
    )}>
      <span className="text-sm">{_.chain(alt).split(" ").slice(0, 2).map(s => s.charAt(0)).join("").upperCase().value()}</span>
    </div>
  );
};


export type AvatarUser = {
  code?: string;
  name?: string;
  username?: string;
  lastName?: string;
  firstName?: string;
  profileImageUrl?: string;
  phoneNumber?: string;
};

export const UserAvatarBlock: FC<{
  user?: AvatarUser | null;
  label: string;
}> = ({ user, label }) => {
  const name = [
    (user?.firstName || "")?.trim(),
    (user?.lastName || "")?.trim(),
  ]
    .join(" ")
    .trim() ||
    user?.name ||
    user?.username ||
    "N/A";


  return (
  <div>
    <p className="text-xs font-light text-gray-500">{label}</p>
    <div className="mt-2 flex items-center">
      <div className="h-10 w-10 flex-shrink-0">
        <Avatar
          disabled
          alt={name}
          src={user?.profileImageUrl || ""}
        />
      </div>
      <div className="ml-4 min-w-0">
        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">
          {name}
        </p>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          {user?.phoneNumber || user?.code || "N/A"}
        </p>
      </div>
    </div>
  </div>
  );
};

export default Avatar;